// extracted by mini-css-extract-plugin
export default {"navbar":"RxqTxSzK","shrink":"yFNE44tl"};